import queryFactory from "./queryFactory";
import orderType from "Types/orderType";

export default {
  useAdminWaited: queryFactory<orderType>({
    tag: "orders/waited/admin",
    url: "/orders/waited/admin",
  }).useAll,
  useLabWaited: queryFactory<orderType>({
    tag: "orders/waited/lab",
    url: "/orders/waited/lab",
  }).useAll,
  useAll: queryFactory<orderType>({
    tag: "users/orders",
    url: "/users/orders",
  }).useAll,
  useRejected: queryFactory<orderType>({
    tag: "users/ordersRejected",
    url: "/users/ordersRejected",
  }).useAll,
  useApproved: queryFactory<orderType>({
    tag: "users/ordersApproved",
    url: "/users/ordersApproved",
  }).useAll,
  useMutate: queryFactory<orderType>({
    tag: "orders",
    url: "/orders",
  }).useMutate,
  useAdminMutate: queryFactory<orderType>({
    tag: "orders/adminupdate",
    url: "/orders/adminupdate",
  }).useMutate,
  useLabMutate: queryFactory<orderType>({
    tag: "orders",
    url: "/orders",
  }).useMutate,
};
